import { createClientApi } from '../generated/clients/createClient';

const createClientCustomApi = createClientApi.enhanceEndpoints({
  endpoints: {
    createClient: {
      invalidatesTags: [{ id: 'LIST', type: 'Clients' as const }],
    },
  },
});

export const { useCreateClientMutation } = createClientCustomApi;
